import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const NAVBAR_OFFSET = 140

export default function ScrollManager() {
    const location = useLocation()

    useEffect(() => {
        const scrollToTarget = () => {
            if (location.hash) {
                const element = document.getElementById(location.hash.slice(1))

                if (element) {
                    const top = element.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET

                    window.scrollTo({
                        top,
                        behavior: 'smooth',
                    })
                    return
                }
            }

            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }

        const frame = window.requestAnimationFrame(scrollToTarget)

        return () => window.cancelAnimationFrame(frame)
    }, [location.pathname, location.hash])

    return null
}
